/* 
 * @author Tommy Brière
 * @copyright (c) 2016 Groupe PVP
 * @fileoverview Utilitaires supplémentaires pour le débogage
 */
(function($g) {
    "use strict";
    
    function time() {
        if (window.performance && performance.now) {
            return performance.now();
        }
        return new Date().getTime();
    }
    
    var timestart;
    var c = window.console;
    
    $g.assert = function (expr, msg) {
        if (!expr) {
            if (c && c.assert) {
                c.assert(expr, msg);
            } else {
                error([msg]);
            }
        }
    };

    $g.time = function (label) {
        timestart = time();
        if (c && c.time) {
            c.time(label);
        }
    };

    $g.timeEnd = function (label) {
        var timeend = time();
        var delta = timeend-timestart;
        $g.log("time", label, delta);
        if (c && c.timeEnd) {
            c.timeEnd(label);
        }
    };

    
})(PVPGEngine);